import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState } from '@auth/store/states/auth.state';

const authSelector = createFeatureSelector<AuthState>('auth');

export const selectInvitation = createSelector(
    authSelector,
    authState => authState != null ? authState.invitation : null
);